// need to add links instead on a tags
import React from 'react'
import styles from './home.module.css'
;


export default function Home() {
  return (
    <>
            <header>
                <img className={styles.background} alt="" src="factory-workshop-interior-machines-glass-production-background-1.png" />
                    <div className={styles.container}>
                    <h1>Business Seek Businesses</h1>
                    <h3>Simplify your journey with Jobbwork. Post Project seamlessly, connect effortlessly</h3>

                    <div className={styles.searchBar}>
                        <img alt="" src="father-icons-search.svg" />
                        <input type="text" placeholder="Search for Industries for eg. Textile" />                            
                    </div>
                  
                    </div>
            </header>

            <section>
                <TopCategories />
                <HalfImage />
                <WhyChoose />
                <Choose />
                
            </section>


    </>

  )
}

const Choose = () => {
    return (
        <div className={styles.services}>
            <h2 className={styles.servicesH2}>Services</h2>
            <div className='flex'>
                <div className={styles.servicesCard}>
                    <img src="image-Post.png" alt="" />
                    <div className={styles.servicesbuttonContainer}>
                        <a href="signup" className={styles.servicesbutton}>Get a Project</a>
                    </div>
                </div>
                <div className={styles.servicesCard}>
                    <img src="image-Seek.png" alt="" />
                    <div className={styles.servicesbuttonContainer}>
                        <a href="/signup" className={styles.servicesbutton}>Post a Project</a>
                    </div>
                </div>
            </div>
        </div>

    )
}

const TopCategories = () => {
  return (
      <>
          <div>
              <h1>Top Categories</h1>
              <div className={styles.cardList}>
                  <div className={styles.card}>
                      <img alt="" src="istockphoto-mechanical.png" />
                      <p>Mechanical</p>
                  </div>
                  <div className={styles.card}>
                      <img alt="" src="image-electronics.png" />
                      <p>Electrical & Electronics</p>
                  </div>
                  <div className={styles.card}>
                      <img alt="" src="image-machinery.png" />
                      <p>Machinery</p>
                  </div>
                  <div className={styles.card}>
                      <img alt="" src="image-automobile.png" />
                      <p>Automobile</p>
                  </div>
              </div>
              <a href="/signup">
              <button className={styles.blueButton}>Explore All</button>
              </a>
          </div>

          <div className={styles.coloredDiv}>
              <div className={styles.carousel}>
                  <img className={styles.image1} alt="" src="image-labour.png" />
                  <img className={styles.image2} alt="" src="image-handshake.png" />
                  <img className={styles.image3} alt="" src="image-building.png" />
              </div>
              <h2>About Jobbwork</h2>
              <h3>Jobbwork empowers businesses to collaborate effortlessly, seamlessly, and with lasting impact. Our platform bridges the gap between businesses, simplifying the process of outsourcing tasks and acquiring specialized expertise. Jobbwork cultivates a thriving ecosystem that fosters collaboration, networking, and enduring partnerships, eliminating the isolation often experienced in business endeavors. Embark on a journey with us to a business world where simplicity, efficiency, and disconnectedness reign supreme.</h3>
          </div>

      </>
  )
}



const HalfImage = () => {
    return (
        <div className={styles.halfImage}>
            <img src="frame-typing.png" alt="" />

            <div className={styles.points}>
                <h1 className={styles.halfImageTitle}>How Jobbwork Works?</h1>
                <br />
                <div>
                    <div className={styles.circle}><h3>1</h3></div>
                    <div>
                        <h1>Create Profile:</h1>
                        <p>Start by crafting a comprehensive profile, showcasing skills and experience for job seekers or detailing company information for businesses.</p>
                    </div>
                </div>

                <svg className='w-[100%] ml-4' width="100" height="300">
        <line x1="50" y1="0" x2="50" y2="300" stroke="black" strokeWidth="2"/>
    </svg>

                <div>
                    <div className={styles.circle}><h3>2</h3></div>
                    <div>
                        <h1>Find or Post Opportunities:</h1>
                        <p>Utilize "Find Project" to discover tailored opportunities (for job seekers) or "Post Project" to attract top talent by showcasing projects and company profile (for businesses).</p>
                    </div>

                </div>

                <svg className='w-[100%] ml-4' width="100" height="300">
        <line x1="50" y1="0" x2="50" y2="300" stroke="black" strokeWidth="2"/>
    </svg>


                <div>
                    <div className={styles.circle}><h3>3</h3></div>
                    <div>
                        <h1>Contact & Collaborate:</h1>
                        <p>Directly connect with others, allowing job seekers to apply to projects and businesses to review applications, communicate, and build successful collaborations.</p>
                    </div>

                </div>
            </div>
        </div>
    )
}




const WhyChoose = () => {
    return (
        <div className={styles.whyChoose}>
            <h2>Why Choose Jobbwork ?</h2>
            <h3>Choose Jobbwrk for a business experience that prioritizes simplicity, efficiency, and direct connections. Whether you're a business seeking services or a business ready to serve, Jobbwrk is the catalyst for meaningful collaborations and business growth. Join us and transform the way you connect and thrive in the business world.</h3>
            <br/>
            <div className={styles.whyPoints}>
                <div>
                    <h1>01.</h1>
                    <p>Cut Out the Middleman, Save Time</p>
                </div>
                <div>
                    <h1>02.</h1>
                    <p>Simplify Collaboration</p>
                </div>
                <div>
                    <h1>03.</h1>
                    <p>Find the Right Partner Quickly</p>
                </div>
                <div>
                    <h1>04.</h1>
                    <p>Bridging Businesses</p>
                </div>
                <div>
                    <h1>05.</h1>
                    <p>Break Free from Isolation</p>
                </div>

            </div>
            <br />
            <a href="/signup">
            <button className={styles.whiteButton}>Learn More</button>
            </a>
        </div>
    )
}






